// Mit diesem Controller kann man ein Formular abschicken (ohne Submit-Button)
// data-controller muss ins form-tag
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit-formular"
export default class extends Controller {
	submit() {
		this.element.requestSubmit()
	}
}
